// src/client/lib/widget-config.js
//
// Public configuration contract for loadReservationWidget(venueId, userConfig).
// Exported via CommonJS so the same module powers both the webpack-bundled
// widget-loader.js and node's unit-test runner.

var DEFAULT_TARGET_ELEMENT_ID = 'ee-reservation-widget';

var DEFAULT_CONFIG = Object.freeze({
  mode: 'modal',
  targetElementId: DEFAULT_TARGET_ELEMENT_ID,
  maxHeight: null
});

var VALID_MODES = Object.freeze({ modal: true, embedded: true });

/**
 * Merge a user-provided config object with defaults. Unknown modes fall back
 * to 'modal' with a console warning. Unknown keys are passed through so
 * future options can be added without breaking callers.
 */
function mergeConfig(userConfig) {
  var cfg = {};
  for (var k in DEFAULT_CONFIG) { cfg[k] = DEFAULT_CONFIG[k]; }
  if (userConfig && typeof userConfig === 'object') {
    for (var key in userConfig) {
      if (userConfig[key] !== undefined) cfg[key] = userConfig[key];
    }
  }
  if (!VALID_MODES[cfg.mode]) {
    if (typeof console !== 'undefined' && console.warn) {
      console.warn('[EE Reservation Widget] Unknown mode "' + cfg.mode + '", falling back to "modal"');
    }
    cfg.mode = 'modal';
  }
  return cfg;
}

module.exports = {
  DEFAULT_TARGET_ELEMENT_ID: DEFAULT_TARGET_ELEMENT_ID,
  DEFAULT_CONFIG: DEFAULT_CONFIG,
  VALID_MODES: VALID_MODES,
  mergeConfig: mergeConfig
};
